import Splide from "@splidejs/splide";

const carousels = document.querySelectorAll<HTMLElement>('.splide');

carousels.forEach((carousel) => {
  const splide = new Splide(carousel, {
    type: 'loop',
    perPage: 1,
    mediaQuery: 'min',
    focus: 0,
    lazyLoad: 'nearby',
    updateOnMove: true,
    keyboard: true,
    drag: true,
  });

  splide.mount();

  splide.on('click', function () {
    openCarouselModal(splide, carousel);
  });
});

// Function to open the correct modal
const openCarouselModal = (splide: Splide, carousel: HTMLElement) => {
  const modal = carousel.closest('.carousel-block__content')?.querySelector<HTMLDialogElement>('.carousel-modal');
  if (!modal) return;

  const selectedSlide = splide.Components.Elements.slides[splide.index];
  const imageBlockContent = selectedSlide.querySelector('.image-block__content');
  const modalContent = modal.querySelector('.image-modal-content');

  if (imageBlockContent && modalContent) {
    modalContent.innerHTML = '';
    modalContent.appendChild(imageBlockContent.cloneNode(true));

    // Disable page scrolling
    document.body.style.overflow = 'hidden';

    modal.showModal();
    modal.focus();
  }

  // Close modal button inside the current modal
  const closeModalButton = modal.querySelector<HTMLButtonElement>('.carousel-modal__close-button');
  closeModalButton?.addEventListener('click', () => {
    modal.close();
    document.body.style.overflow = '';

    splide.go(splide.index);
  });
};